import { Component, Ref } from '@eastsideco/salvo-ts';
import { cart } from "@/theme/Cart";
import { ThemeComponent } from "@/theme/ThemeComponent";
import { CartMain } from "../Cart/CartMain";
import { SideCart } from '../SideCart/SideCart';
import SimpleParallax from 'simple-parallax-js';
import ScrollMagic from 'scrollmagic';

export interface SelectedProducts {
    id: number;
    quantity: number;
}
@Component
export class LightDarkText extends ThemeComponent {
    @Ref({required: false}) button!: HTMLButtonElement;
    @Ref({required: false}) closeButton!: HTMLButtonElement;
    @Ref({required: false}) addToCart!: HTMLButtonElement;
    @Ref({required: false}) deselectAll!: HTMLButtonElement;
    @Ref({required: false}) drawer!: HTMLDivElement;
    @Ref({required: false}) overlay!: HTMLDivElement;
    @Ref({required: false}) multiSelectProduct!: HTMLInputElement[];
    @Ref images!: HTMLElement;
    @Ref image!: HTMLElement[];

    protected quantityVal: number = 1;
    private section: HTMLDivElement = document.querySelector('.js-light-dark-text') as HTMLDivElement;
    private cartMain: CartMain = document.body.querySelector('cart-main') as CartMain;
    private sideCart: SideCart | null = document.body.querySelector('side-cart');

    /**
     * Initialise.
     */
    init() {
        if (!this.button) { return; }

        this.$listen(this.button, 'click', (event) => {
            event.preventDefault();
            this.toggleDrawer();
        });

        this.$listen(this.closeButton, 'click', (event) => {
            event.preventDefault();
            this.closeDrawer();
        });

        this.$listen(this.overlay, 'click', (event) => {
            event.preventDefault();
            this.closeDrawer();
        });

        this.$listen(this.addToCart, 'click', (event) => {
            event.preventDefault();
            void this.addProductsToCart();
        });

        this.$listen(this.deselectAll, 'click', (event) => {
            event.preventDefault();

            this.deselectAllProducts();
        });
    }

    toggleDrawer() {
        this.overlay.classList.toggle('is-active');
        this.drawer.classList.toggle('is-active');
        this.section.classList.toggle('is-active');
        document.body.classList.toggle('no-scroll');
    }

    closeDrawer() {
        this.overlay.classList.remove('is-active');
        this.drawer.classList.remove('is-active');
        this.section.classList.remove('is-active');
        document.body.classList.remove('no-scroll');
    }

    deselectAllProducts() {
        for (const product of this.multiSelectProduct) {
            product.checked = false;
        }
    }

    protected async addProductsToCart() {
        const selectedProductsArr = [];

        for (const product of this.multiSelectProduct) {
            if (product.checked) {
                const selectedProductsObj = {} as SelectedProducts;

                selectedProductsObj.id = Number(product.id);
                selectedProductsObj.quantity = 1;
                selectedProductsArr.push(selectedProductsObj);
            }
        }

        await cart.addItems(selectedProductsArr)
            .then((items) => {
                // Dispatch event for other components to listen to
                document.dispatchEvent(new Event('cartChanged'));
            })

            .catch((event: unknown | null) => {
                if (event instanceof Error) {
                    this.showError(event.message);
                }
            });
    }

    protected showError(msg: string | null): void {
        this.$log.info(msg?msg:'');
    }
}
